module.exports = __webpack_public_path__ + "img/ic-close-small-light.1bd85ea7.svg";